/** Totals per currency, ordered by currency code so the output is stable. */
export function sumByCurrency(amounts) {
    const totals = new Map();
    for (const amount of amounts) {
        if (amount === null || amount === undefined)
            continue;
        totals.set(amount.currency, (totals.get(amount.currency) ?? 0) + amount.minor);
    }
    return [...totals.entries()]
        .map(([currency, minor]) => ({ currency, minor }))
        .sort((a, b) => a.currency.localeCompare(b.currency));
}
/**
 * A single figure for ordering totals against each other.
 *
 * Deliberately not a conversion: there are no exchange rates here and there will
 * not be. It exists so that "the biggest category first" has a defined meaning
 * when two categories hold different currencies, and it is never shown to anyone
 * -- the displayed figures stay grouped by currency.
 */
export const rankOf = (totals) => totals.reduce((sum, total) => sum + total.minor, 0);
//# sourceMappingURL=money.js.map